<div class="row document overflow-hidden">
  <div class="col-12 document overflow-hidden">
    <div class="d-flex justify-content-between">
      <p class="warning"><span *ngIf="showWarning">{{"messages.warning_data_lot" | translate}}</span></p>
      <a class="view-docx" (click)="preview($event)">{{ "button.view_docx" | translate }}</a>
    </div>
    <app-form-template class="form-handsontable" #formTemplate></app-form-template>
    <!-- <mat-tab-group class="document overflow-hidden">
      <mat-tab [label]="'title.settings_info' | translate">
        
      </mat-tab> -->
    <!-- <mat-tab [label]="'title.settings_footnote' | translate">
        <app-footnote #signature></app-footnote>
      </mat-tab> -->
    <!-- <mat-tab disabled>
        <ng-template mat-tab-label>
          
        </ng-template>
      </mat-tab>
    </mat-tab-group> -->
  </div>
</div>